const initBlog = () => {
    jQuery('.js-toc-trigger').on('click', function() {
      if(window.matchMedia("(max-width: 992px)").matches) {
        jQuery('.RightsSideBar').toggleClass('is-open');
      }
    });
}

export {initBlog};